import { render, staticRenderFns } from "./CustomerRateEditor.vue?vue&type=template&id=13b54156&scoped=true"
import script from "./CustomerRateEditor.vue?vue&type=script&lang=js"
export * from "./CustomerRateEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b54156",
  null
  
)

export default component.exports